import { Module } from "wrapper6";
import { toggleClass, hasClass, removeClass, addClass } from "../utils/_class-handlers";

var $ = jQuery;

export default class ArticlesFilter extends Module {

	ready() {

        const NEWS_WRAPPERS = document.querySelectorAll('.mtt-news-loop');

        if (NEWS_WRAPPERS.length > 0) {

            for (let i = 0; i < NEWS_WRAPPERS.length; i++) {

                // Elements
                const NEWS_WRAPPER = NEWS_WRAPPERS[i];
                const TOGGLE_WRAPPER = NEWS_WRAPPER.querySelector('.toggle-container');
                const TOGGLES = NEWS_WRAPPER.querySelectorAll('.toggle');
                const DIST = NEWS_WRAPPER.querySelector('.news-wrapper');
                const LOADER = NEWS_WRAPPER.querySelector('.loader-overlay');
                
                if (TOGGLES && TOGGLE_WRAPPER) {

                    let elements = { NEWS_WRAPPER, TOGGLES, DIST, LOADER };
                    let vars = {
                        is_podcasts: hasClass(NEWS_WRAPPER, 'has-podcasts'),
                        card: NEWS_WRAPPER.getAttribute('data-card'),
                        universe: TOGGLE_WRAPPER.getAttribute('data-universe')
                    };

                    for (let i = 0; i < TOGGLES.length; i++) {

                        const TOGGLE = TOGGLES[i];

                        TOGGLE.addEventListener('click', () => {

                            // Set toggle to active, remove from siblings
                            for (let i = 0; i < TOGGLES.length; i++) {
                                removeClass(TOGGLES[i], 'active');
                            }
                            addClass(TOGGLE, 'active');

                            // Get type
                            vars.type = TOGGLE.getAttribute('data-toggle');

                            // Ajax request
                            get_articles(elements, vars);

                        });
                    }
                }
            }
        }

		// Ajax request function
        let get_articles = function (elements, vars) {
    
            // Show loader
            addClass(elements.LOADER, 'show');

            // Set ajax data
            let data = {
                'action': vars.is_podcasts ? 'filter_podcasts' : 'filter_articles',
                'type': vars.type,
                'card': vars.card,
                'universe': vars.universe
            };

            // Ajax call
            jQuery.post(main_theme_objects.ajax_url, data, function(response) {

                if (response != 0) {

                    // Post response
                    elements.DIST.innerHTML = response.articles;

                    // Hide loader
                    removeClass(elements.LOADER, 'show');

                    // // Animate body to top
                    // $('html, body').animate({ 
                    //     scrollTop: $('.'+elements.NEWS_WRAPPER.className).offset().top - 130
                    // }, 800);
                }
            });
        }
	}
}